import { EventEmitter, Component, Input, Output, Directive, ElementRef, Renderer2, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function ButtonComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵelement(1, "img", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.iconUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function ButtonComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵelement(1, "img", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r1.iconUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
const _c0 = function (a0, a1, a2, a3, a4, a5, a6, a7) { return { solid: a0, outline: a1, text: a2, large: a3, medium: a4, small: a5, "large-mobile": a6, "small-mobile": a7 }; };
const _c1 = function (a0, a1, a2, a3, a4) { return { "border-top-left-radius": a0, "border-bottom-left-radius": a1, "border-top-right-radius": a2, "border-bottom-right-radius": a3, width: a4 }; };
class ButtonComponent {
    constructor() {
        this.name = "Enabled";
        this.type = "Solid";
        this.size = "Medium";
        this.width = "";
        this.showIcon = false;
        this.iconUrl = "";
        this.iconPosition = "Left";
        this.disabled = false;
        this.disableLeftBorderRadius = false;
        this.disableRightBorderRadius = false;
        /** Emits event when button is clicked */
        this.click = new EventEmitter();
    }
    ngOnInit() { }
    onClick(event) {
        this.click.emit(event);
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["mis-button"]], inputs: { name: "name", type: "type", size: "size", width: "width", showIcon: "showIcon", iconUrl: "iconUrl", iconPosition: "iconPosition", disabled: "disabled", disableLeftBorderRadius: "disableLeftBorderRadius", disableRightBorderRadius: "disableRightBorderRadius" }, outputs: { click: "click" }, decls: 4, vars: 21, consts: [[3, "disabled", "ngClass", "ngStyle", "click"], ["id", "left-icon", 4, "ngIf"], ["id", "right-icon", 4, "ngIf"], ["id", "left-icon"], ["alt", "", 3, "src"], ["id", "right-icon"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function ButtonComponent_Template_button_click_0_listener($event) { return ctx.onClick($event); });
        ɵngcc0.ɵɵtemplate(1, ButtonComponent_span_1_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵtemplate(3, ButtonComponent_span_3_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("ngClass", ɵngcc0.ɵɵpureFunction8(6, _c0, ctx.type === "Solid", ctx.type === "Outline", ctx.type === "Text", ctx.size === "Large", ctx.size === "Medium", ctx.size === "Small", ctx.size === "Large-M", ctx.size === "Small-M"))("ngStyle", ɵngcc0.ɵɵpureFunction5(15, _c1, ctx.disableLeftBorderRadius ? "0px" : "", ctx.disableLeftBorderRadius ? "0px" : "", ctx.disableRightBorderRadius ? "0px" : "", ctx.disableRightBorderRadius ? "0px" : "", ctx.width));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showIcon && ctx.iconPosition === "Left");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.name, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showIcon && ctx.iconPosition === "Right");
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgStyle], styles: ["button[_ngcontent-%COMP%]{font-family:Lato,sans-serif!important;border:none;padding:0;margin:0;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#181f33;background-color:#fff}.solid[_ngcontent-%COMP%]{color:#fff;background:#0937b2}.solid[_ngcontent-%COMP%]:hover:enabled{background:#062a99}.solid[_ngcontent-%COMP%]:active:enabled{background:#041f80}.solid[_ngcontent-%COMP%]:disabled{color:#929dab;background:#f5f5f5}.outline[_ngcontent-%COMP%]{border:1px solid #0937b2;color:#0937b2;background:#fff}.outline[_ngcontent-%COMP%]:hover:enabled{background:#f0f3fa}.outline[_ngcontent-%COMP%]:active:enabled{background:#dae1f3}.outline[_ngcontent-%COMP%]:disabled{color:#929dab;border:1px solid #929dab}.text[_ngcontent-%COMP%]{color:#181f33;background:#fff}.text[_ngcontent-%COMP%]:hover:enabled{background:#f0f3fa}.text[_ngcontent-%COMP%]:active:enabled{background:#dae1f3}.text[_ngcontent-%COMP%]:disabled{color:#929dab}.large[_ngcontent-%COMP%]{height:56px;padding:16px;border-radius:10px;font-weight:700;letter-spacing:.5px}.large[_ngcontent-%COMP%], .medium[_ngcontent-%COMP%]{font-style:normal;font-size:16px;line-height:24px}.medium[_ngcontent-%COMP%]{height:44px;padding:10px 16px;border-radius:8px;font-weight:400;letter-spacing:.2px}.small[_ngcontent-%COMP%]{height:32px;padding:6px 16px;border-radius:6px;font-weight:400;letter-spacing:.25px}.large-mobile[_ngcontent-%COMP%], .small[_ngcontent-%COMP%]{font-style:normal;font-size:14px;line-height:20px}.large-mobile[_ngcontent-%COMP%]{height:44px;padding:12px}.large-mobile[_ngcontent-%COMP%], .small-mobile[_ngcontent-%COMP%]{border-radius:8px;font-weight:700;letter-spacing:.1px}.small-mobile[_ngcontent-%COMP%]{height:32px;padding:6px 12px;font-style:normal;font-size:14px;line-height:20px}span[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}#left-icon[_ngcontent-%COMP%]{margin-right:8px}#right-icon[_ngcontent-%COMP%]{margin-left:8px}"] });
ButtonComponent.ctorParameters = () => [];
ButtonComponent.propDecorators = {
    name: [{ type: Input }],
    type: [{ type: Input }],
    size: [{ type: Input }],
    width: [{ type: Input }],
    showIcon: [{ type: Input }],
    iconUrl: [{ type: Input }],
    iconPosition: [{ type: Input }],
    disabled: [{ type: Input }],
    disableLeftBorderRadius: [{ type: Input }],
    disableRightBorderRadius: [{ type: Input }],
    click: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{ selector: "mis-button", template: "<button\n  (click)=\"onClick($event)\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"{\n    solid: type === 'Solid',\n    outline: type === 'Outline',\n    text: type === 'Text',\n    large: size === 'Large',\n    medium: size === 'Medium',\n    small: size === 'Small',\n    'large-mobile': size === 'Large-M',\n    'small-mobile': size === 'Small-M'\n  }\"\n  [ngStyle]=\"{\n    'border-top-left-radius': disableLeftBorderRadius ? '0px' : '',\n    'border-bottom-left-radius': disableLeftBorderRadius ? '0px' : '',\n    'border-top-right-radius': disableRightBorderRadius ? '0px' : '',\n    'border-bottom-right-radius': disableRightBorderRadius ? '0px' : '',\n    width: width\n  }\"\n>\n  <span id=\"left-icon\" *ngIf=\"showIcon && iconPosition === 'Left'\">\n    <img [src]=\"iconUrl\" alt=\"\" />\n  </span>\n  {{ name }}\n  <span id=\"right-icon\" *ngIf=\"showIcon && iconPosition === 'Right'\">\n    <img [src]=\"iconUrl\" alt=\"\" />\n  </span>\n</button>\n", styles: ["button{font-family:Lato,sans-serif!important;border:none;padding:0;margin:0;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#181f33;background-color:#fff}.solid{color:#fff;background:#0937b2}.solid:hover:enabled{background:#062a99}.solid:active:enabled{background:#041f80}.solid:disabled{color:#929dab;background:#f5f5f5}.outline{border:1px solid #0937b2;color:#0937b2;background:#fff}.outline:hover:enabled{background:#f0f3fa}.outline:active:enabled{background:#dae1f3}.outline:disabled{color:#929dab;border:1px solid #929dab}.text{color:#181f33;background:#fff}.text:hover:enabled{background:#f0f3fa}.text:active:enabled{background:#dae1f3}.text:disabled{color:#929dab}.large{height:56px;padding:16px;border-radius:10px;font-weight:700;letter-spacing:.5px}.large,.medium{font-style:normal;font-size:16px;line-height:24px}.medium{height:44px;padding:10px 16px;border-radius:8px;font-weight:400;letter-spacing:.2px}.small{height:32px;padding:6px 16px;border-radius:6px;font-weight:400;letter-spacing:.25px}.large-mobile,.small{font-style:normal;font-size:14px;line-height:20px}.large-mobile{height:44px;padding:12px}.large-mobile,.small-mobile{border-radius:8px;font-weight:700;letter-spacing:.1px}.small-mobile{height:32px;padding:6px 12px;font-style:normal;font-size:14px;line-height:20px}span{display:flex;justify-content:center;align-items:center}#left-icon{margin-right:8px}#right-icon{margin-left:8px}"] }]
    }], function () { return []; }, { name: [{
            type: Input
        }], type: [{
            type: Input
        }], size: [{
            type: Input
        }], width: [{
            type: Input
        }], showIcon: [{
            type: Input
        }], iconUrl: [{
            type: Input
        }], iconPosition: [{
            type: Input
        }], disabled: [{
            type: Input
        }], disableLeftBorderRadius: [{
            type: Input
        }], disableRightBorderRadius: [{
            type: Input
        }], click: [{
            type: Output
        }] }); })();

class ButtonDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.type = "none";
        this.size = "md";
        this.elementClass = "mis-btn";
    }
    ngAfterViewInit() {
        this.bindTypeClass();
        this.bindSizeClass();
    }
    bindTypeClass() {
        let className = "";
        switch (this.type) {
            case "primary":
                className = "mis-primary";
                break;
            case "outline":
                className = "mis-outline";
                break;
            default:
                className = "mis-none";
        }
        this.renderer.addClass(this.el.nativeElement, className);
    }
    bindSizeClass() {
        let className = "";
        switch (this.size) {
            case "lg":
                className = "mis-btn-lg";
                break;
            case "sm":
                className = "mis-btn-sm";
                break;
            default:
                className = "mis-btn-md";
        }
        this.renderer.addClass(this.el.nativeElement, className);
    }
}
ButtonDirective.ɵfac = function ButtonDirective_Factory(t) { return new (t || ButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ButtonDirective, selectors: [["", "mis-button", ""]], hostVars: 2, hostBindings: function ButtonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.elementClass);
    } }, inputs: { type: "type", size: "size" } });
ButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ButtonDirective.propDecorators = {
    type: [{ type: Input }],
    size: [{ type: Input }],
    elementClass: [{ type: HostBinding, args: ["class",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonDirective, [{
        type: Directive,
        args: [{
                selector: "[mis-button]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { type: [{
            type: Input
        }], size: [{
            type: Input
        }], elementClass: [{
            type: HostBinding,
            args: ["class"]
        }] }); })();

class ButtonModule {
    static forRoot() {
        return { ngModule: ButtonModule, providers: [] };
    }
}
ButtonModule.ɵfac = function ButtonModule_Factory(t) { return new (t || ButtonModule)(); };
ButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ButtonModule });
ButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [ButtonComponent, ButtonDirective],
                imports: [CommonModule],
                exports: [ButtonComponent, ButtonDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonModule, { declarations: function () { return [ButtonComponent, ButtonDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ButtonComponent, ButtonDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, ButtonDirective, ButtonModule };

